import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { injectIntl, useIntl } from 'react-intl';
import enumCache from '@/shared/services/EnumCacheService';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import intlShape from '@/shared/utils/intlShape';
import RelationHandlingLevel from '@/shared/components/RelationHandlingLevel';

class RelationHandlingLevelButtonGroup extends Component {
  state = {
    relationHandlingLevels: [],
  };

  componentDidMount() {
    const { intl } = this.props;
    enumCache.get('relationhandlinglevel').then(relationHandlingLevels => {
      this.setState({
        relationHandlingLevels: relationHandlingLevels.map(item => ({
          id: item.key,
          label: intl.formatMessage(listItemMsg('relationhandlinglevel', item.key, item.value)),
        })),
      });
    });
  }

  toggleRelationHandlingLevel = relHandlingLevel => {
    const { selectedHandlingLevels = [], onChange } = this.props;
    const idx = selectedHandlingLevels.indexOf(relHandlingLevel);
    if (idx >= 0) {
      onChange(selectedHandlingLevels.filter((_, i) => i !== idx));
    } else {
      onChange([...selectedHandlingLevels, relHandlingLevel]);
    }
  };
  render() {
    const { relationHandlingLevels } = this.state;
    const { selectedHandlingLevels = [] } = this.props;

    return (
      <div
        role="group"
        aria-label="relationHandlingLevel"
        className="btn-group btn-group-justified"
      >
        {relationHandlingLevels &&
          relationHandlingLevels.map(t => (
            <button
              key={`RelHandlingLevelFilter${t.id}`}
              onClick={() => {
                document.activeElement.blur();
                this.toggleRelationHandlingLevel(t.id);
              }}
              type="button"
              title={t.label}
              className={classnames('btn btn-default no-overflow', {
                active: selectedHandlingLevels.includes(t.id),
              })}
            >
              <RelationHandlingLevel handlingLevel={t.id} clarification={t.label} />
              {t.label}
            </button>
          ))}
      </div>
    );
  }
}
RelationHandlingLevelButtonGroup.propTypes = {
  intl: intlShape.isRequired,
  selectedHandlingLevels: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func.isRequired,
};

RelationHandlingLevelButtonGroup.defaultProps = {
  selectedHandlingLevels: [],
};

export default injectIntl(RelationHandlingLevelButtonGroup);
